import {observable} from 'mobx';

export class VideoControlState {
    @observable isActive: boolean = false;

    @observable videoReady: boolean = false;

    @observable videoChangeLock: boolean = false;
}
